import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'

import cookies from '@/utils/cookie'

import { cloneDeep } from 'lodash'

const adapter = new LocalStorage(`examination`)
const db = low(adapter)

db.defaults({ sys: {}, database: {} }).write()

export default db

// 检查路径是否存在 不存在的话初始化
export function pathInit({ dbName = 'database', path = '', user = true, validator = () => true, defaultValue = '' }) {
	const uuid = cookies.get('uuid') || 'ghost-uuid'
	const currentPath = `${dbName}.${user ? `user.${uuid}` : 'public'}${path ? `.${path}` : ''}`
	const value = db.get(currentPath).value()
	if (!(value !== undefined && validator(value))) {
		db.set(currentPath, defaultValue).write()
	}
	return currentPath
}

// 将数据存储到指定位置 | 路径不存在会自动初始化
export function dbSet({ dbName = 'database', path = '', value = '', user = false }) {
	db.set(pathInit({ dbName, path, user }), value).write()
}

// 获取数据
export function dbGet({ dbName = 'database', path = '', defaultValue = '', user = false }) {
	return cloneDeep(db.get(pathInit({ dbName, path, user, defaultValue })).value())
}

// 删除数据
// value = '',
export function dbDel({ dbName = 'database', path = '', delKey = '', user = false }) {
	let delPath = delKey ? pathInit({ dbName, path, user }) + '.' + delKey : pathInit({ dbName, path, user })
	return db.unset(delPath).write()
}

// 获取存储数据库对象
export function getDatabase({ dbName = 'database', path = '', user = false, validator = () => true, defaultValue = '' } = {}) {
	return db.get(pathInit({ dbName, path, user, validator, defaultValue }))
}
